/**
 * Transforme toutes les div contenant la class owlSlider en slider
 * Les paramètres ci-dessous peuvent être passés en configuration via les attributs data de la div maitresse
 */
class OsmMap{
  constructor(){
    jQuery('.osm-map').each(function(){
      var myMap = L.map(this, {
        center: [ jQuery(this).data('lat'), jQuery(this).data('lng')],
        zoom: 8,
        dragging: !L.Browser.mobile,
        touchZoom: true,
        tap: false,
      });

      L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', {attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'}).addTo(myMap);

      L.marker([jQuery(this).data('lat'),jQuery(this).data('lng')],{title: jQuery(this).data('title')}).addTo(myMap);
    })
  }
}

export default OsmMap;



// WEBPACK FOOTER //
// ./scripts/util/OsmMap.js